import { render, staticRenderFns } from "./WealthInvest.vue?vue&type=template&id=c9fb9fb4&scoped=true"
import script from "./WealthInvest.vue?vue&type=script&lang=ts&setup=true"
export * from "./WealthInvest.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WealthInvest.vue?vue&type=style&index=0&id=c9fb9fb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fb9fb4",
  null
  
)

export default component.exports